// This file configures the initialization of Sentry for Vite apps.
// https://docs.sentry.io/platforms/javascript/guides/react/

import { initSentryVite } from '@makanly/sentry/frontend';

export function initSentry() {
  initSentryVite({
    app: 'system-status',
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    tracesSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || '0.1'),
    replaysSessionSampleRate: parseFloat(
      import.meta.env.VITE_SENTRY_REPLAYS_SESSION_RATE || '0.01',
    ),
    replaysOnErrorSampleRate: parseFloat(import.meta.env.VITE_SENTRY_REPLAYS_ERROR_RATE || '1.0'),
  });
}
